var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsAiassistantAianalysis = function SvgNewcsAiassistantAianalysis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_aiassistant_aianalysis_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#newcs_aiassistant_aianalysis_svg__b)",
    d: "M1.9 4.39c.05 0 .1.03.12.09.24.83.88 1.47 1.71 1.7.06.02.09.09.07.15a.12.12 0 0 1-.07.07c-.83.23-1.48.88-1.71 1.71-.02.07-.1.1-.16.08-.04-.01-.06-.04-.08-.08C1.55 7.28.91 6.63.08 6.4c-.06-.02-.09-.09-.07-.15a.12.12 0 0 1 .07-.07c.83-.23 1.47-.88 1.7-1.7.02-.05.07-.09.12-.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#newcs_aiassistant_aianalysis_svg__c)",
    d: "M12.72 3.27v.01l-.01-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#newcs_aiassistant_aianalysis_svg__d)",
    d: "M8.95 9.67h-.44c-.16 0-.3-.1-.35-.25l-.31-.89H5.99l-.31.89c-.05.15-.19.25-.35.25h-.44c-.25 0-.43-.25-.34-.49l1.57-4.29c.12-.34.44-.56.8-.56s.68.22.8.56L9.3 9.18c.09.24-.09.49-.34.49zM6.9 5.86l-.54 1.58h1.12l-.54-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#newcs_aiassistant_aianalysis_svg__e)",
    d: "M11.13 4.91v4.18a.58.58 0 0 1-1.16 0V4.91a.58.58 0 0 1 1.16 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#newcs_aiassistant_aianalysis_svg__f)",
    d: "M8.04 13.85c-2.55 0-4.85-1.41-6-3.68a.81.81 0 0 1 .35-1.08.81.81 0 0 1 1.08.35 5.11 5.11 0 0 0 4.57 2.81c2.83 0 5.13-2.3 5.13-5.13S10.87 2 8.04 2c-1.5 0-2.92.66-3.9 1.8-.29.34-.79.38-1.13.09a.796.796 0 0 1-.09-1.13A6.74 6.74 0 0 1 8.04.4c3.71 0 6.73 3.02 6.73 6.73s-3.02 6.73-6.73 6.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#newcs_aiassistant_aianalysis_svg__g)",
    d: "m11.647 12.445 2.906 2.907a.85.85 0 0 0 1.202-1.203l-2.906-2.906a.85.85 0 0 0-1.202 1.202"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_aianalysis_svg__b",
    x1: 0.46,
    x2: 3.34,
    y1: 5.47,
    y2: 7.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ABEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_aianalysis_svg__c",
    x1: 12.71,
    x2: 12.72,
    y1: 3.27,
    y2: 3.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8D6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_aianalysis_svg__d",
    x1: 5.44,
    x2: 9.39,
    y1: 6.71,
    y2: 8.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8D6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_aianalysis_svg__e",
    x1: 9.56,
    x2: 11.62,
    y1: 6.14,
    y2: 7.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6A9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8D6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_aianalysis_svg__f",
    x1: 3.71,
    x2: 12.36,
    y1: 1.97,
    y2: 12.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8D6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F54FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_aianalysis_svg__g",
    x1: 15.694,
    x2: 11.572,
    y1: 15.29,
    y2: 11.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD40FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F54FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_aiassistant_aianalysis_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgNewcsAiassistantAianalysis;